import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Alert } from '../../../../../domain/models/alert';
import { AlertType } from '../../../../../domain/enums/alertType';
import * as _ from 'lodash';

@Component({
  selector: 'app-delete-alert',
  templateUrl: './delete-alert.component.html',
  styleUrls: ['./delete-alert.component.scss']
})
export class DeleteAlertComponent implements OnInit {
  @Input() alert: Alert;
  @Output() onConfirm = new EventEmitter<string>();
  @Output() onCancel = new EventEmitter<void>();

  private formLocked: boolean;

  constructor() { }

  ngOnInit() {
    this.formLocked = false;
  }

  confirmDelete(): void {
    if (!this.formLocked) {
      this.formLocked = true;
      this.onConfirm.emit(this.alert.id);
    }
  }

  cancelDelete(): void {
    this.onCancel.emit();
  }

  isTravelTimeAlert(alert: Alert): boolean {
    return alert.type === AlertType.TravelTime;
  }

  isTravelSpeedAlert(alert: Alert): boolean {
    return alert.type === AlertType.TravelSpeed;
  }

  hasMinDuration(alert: Alert): boolean {
    return !_.isUndefined(alert.minDuration) && alert.minDuration != null;
  }

  hasRepeat(alert: Alert): boolean {
    return !_.isUndefined(alert.repeat) && alert.repeat != null;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/alert-overview/components/delete-alert/delete-alert.component.ts